// App.js
import React from 'react';
import DcaSimulator from './components/DcaSimulator';

function App() {
  return (
    <div className="App">
      <DcaSimulator />
    </div>
  );
}

export default App;
